import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  uploadBillingData(context, payload) {
    return axios
      .post("/api/carrier-consignment-billing/upload", payload)
      .then((res) => res.data);
  },

  downloadBillingTemplate() {
    return axios
      .get(
        `/api/file_download?file_path=app_packages/template/Consignment_Billing.xlsx`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  pendingBillingList(context, payload) {
    return axios
      .get(`/api/lastmile-billing-pending-summary/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  billingDataList(context, payload) {
    return axios
      .get(`/api//lastmile-billing-dataavailable/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  pendingBillingOrderList(context, payload) {
    return axios
      .get(`/api/lastmile-pending-order/list?`, {
        params: payload,
      })
      .then((res) => res.data);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
